if (!customElements.get('dual-media-slider')) {
  customElements.define(
    'dual-media-slider',
    class DualMediaSlider extends HTMLElement {
      constructor() {
        super();
        this.currentPage = 0;
        this.pages = this.querySelectorAll('.product-dual-slider__page');
        this.totalPages = this.pages.length;
        this.prevBtn = this.querySelector('.product-dual-slider__arrow--prev');
        this.nextBtn = this.querySelector('.product-dual-slider__arrow--next');

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(1));

        this.updateArrows();
      }

      go(dir) {
        const next = this.currentPage + dir;
        if (next < 0 || next >= this.totalPages) return;

        this.pages[this.currentPage].classList.remove('is-active');
        this.currentPage = next;
        this.pages[this.currentPage].classList.add('is-active');

        const track = this.querySelector('.product-dual-slider__track');
        track.style.transform = `translateX(-${this.currentPage * 100}%)`;

        this.updateArrows();
      }

      updateArrows() {
        if (this.prevBtn) this.prevBtn.classList.toggle('is-hidden', this.currentPage === 0);
        if (this.nextBtn) this.nextBtn.classList.toggle('is-hidden', this.currentPage >= this.totalPages - 1);
      }
    }
  );
}
